import React, { useEffect, useRef, useState } from "react";
import { interesCorto, partirInteres } from "../../../utils/cursoCorto";

/** Los cursos con el nombre que usa el router (CURSO_MAP) y el catálogo del bot. */
export const CURSOS = [
	"Barbería", "Belleza General", "Cejas, Pestañas y Microblading", "Electrónica Inverter", "Estética Facial y Spa", "Estilismo",
	"Finanzas Personales", "Gastronomía", "Inglés", "Manicure y Acrilismo", "Maquillaje", "Marketing Digital", "Mixología",
	"Panadería", "Refrigeración", "Reparación de Celulares", "Repostería y Pastelería",
];

/** "Barbería; Estilismo", "Barbería, Estilismo" o "Barberia Estilista" -> ["Barbería", "Estilismo"]. Zoho guarda la selección múltiple con ";"; imports viejos los pegaban con espacio. */
export const cursosDe = (t: string | null | undefined): string[] => partirInteres(t);

/** El primero manda para cotizar y buscar horarios. */
export const primerCurso = (t: string | null | undefined): string | null => cursosDe(t)[0] || null;

/** Curso de interés de selección múltiple (Esteban, 2026-10-02): se marcan los que pidió; se guarda "A; B". */
const CursosSelect: React.FC<{ value: string; onChange: (v: string) => void; id?: string }> = ({ value, onChange, id }) => {
	const elegidos = cursosDe(value);
	const otros = elegidos.filter((c) => !CURSOS.includes(c));
	const alternar = (c: string) => onChange((elegidos.includes(c) ? elegidos.filter((x) => x !== c) : [...elegidos, c]).join("; "));
	return (
		<div className="cv-cursos" id={id} role="group" aria-label="Curso de interés">
			{[...CURSOS, ...otros].map((c) => (
				<button key={c} type="button" className={"cv-curso" + (elegidos.includes(c) ? " on" : "")} aria-pressed={elegidos.includes(c)} onClick={() => alternar(c)}>{c}</button>
			))}
		</div>
	);
};

export default CursosSelect;

/** Por área, para el buscador de "+ Agregar curso". */
const AREAS: { area: string; cursos: string[] }[] = [
	{ area: "Belleza", cursos: ["Barbería", "Belleza General", "Cejas, Pestañas y Microblading", "Estética Facial y Spa", "Estilismo", "Manicure y Acrilismo", "Maquillaje"] },
	{ area: "Gastronomía", cursos: ["Gastronomía", "Mixología", "Panadería", "Repostería y Pastelería"] },
	{ area: "Técnicos", cursos: ["Electrónica Inverter", "Refrigeración", "Reparación de Celulares"] },
	{ area: "Negocios e idiomas", cursos: ["Finanzas Personales", "Inglés", "Marketing Digital"] },
];
const plano = (t: string) => t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

/**
 * Cursos de interés compactos (Esteban, 2026-10-06: "está bien de multiselección pero se mira extraño así todo amplio"):
 * solo los elegidos, con ×, y "+ Agregar curso" abre un buscador por área con casillas. Mismo valor "A; B".
 */
export const CursosCompacto: React.FC<{ value: string; onChange: (v: string) => void }> = ({ value, onChange }) => {
	const elegidos = cursosDe(value);
	const [abierto, setAbierto] = useState(false);
	const [busca, setBusca] = useState("");
	const caja = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (!abierto) return;
		const cerrar = (e: MouseEvent) => { if (caja.current && !caja.current.contains(e.target as Node)) setAbierto(false); };
		const esc = (e: KeyboardEvent) => { if (e.key === "Escape") setAbierto(false); };
		document.addEventListener("mousedown", cerrar);
		document.addEventListener("keydown", esc);
		return () => { document.removeEventListener("mousedown", cerrar); document.removeEventListener("keydown", esc); };
	}, [abierto]);
	const alternar = (c: string) => onChange((elegidos.includes(c) ? elegidos.filter((x) => x !== c) : [...elegidos, c]).join("; "));
	const otros = elegidos.filter((c) => !CURSOS.includes(c));
	const areas = [...AREAS, ...(otros.length ? [{ area: "Otros", cursos: otros }] : [])]
		.map((a) => ({ ...a, cursos: a.cursos.filter((c) => !busca.trim() || plano(c).includes(plano(busca.trim()))) }))
		.filter((a) => a.cursos.length);
	return (
		<div className="fx-cursos" ref={caja}>
			{elegidos.map((c) => (
				<span key={c} className="fx-curso" title={c}>{interesCorto(c)}<button type="button" onClick={() => alternar(c)} aria-label={"Quitar " + c}>×</button></span>
			))}
			{!elegidos.length ? <span className="fx-vacio">Ninguno todavía</span> : null}
			<button type="button" className="fx-curso-mas" aria-expanded={abierto} onClick={() => { setAbierto(!abierto); setBusca(""); }}>+ Agregar curso</button>
			{abierto ? (
				<div className="fx-pop fx-pop-cursos" role="dialog" aria-label="Elegir cursos">
					<input className="fx-buscar" autoFocus placeholder="Buscar curso" value={busca} onChange={(e) => setBusca(e.target.value)} aria-label="Buscar curso" />
					<div className="fx-pop-lista">
						{areas.map((a) => (
							<React.Fragment key={a.area}>
								<div className="fx-pop-grupo">{a.area}</div>
								{a.cursos.map((c) => {
									const on = elegidos.includes(c);
									return (
										<button key={c} type="button" className="fx-op" aria-pressed={on} onClick={() => alternar(c)}>
											<span className={"fx-caja" + (on ? " on" : "")} aria-hidden="true">{on ? "✓" : ""}</span>{interesCorto(c)}
										</button>
									);
								})}
							</React.Fragment>
						))}
						{!areas.length ? <div className="fx-vacio" style={{ padding: "8px 12px" }}>Sin resultados.</div> : null}
					</div>
					<div className="fx-pop-pie"><span>{elegidos.length} {elegidos.length === 1 ? "elegido" : "elegidos"}</span><button type="button" className="crm-b negro chico" onClick={() => setAbierto(false)}>Listo</button></div>
				</div>
			) : null}
		</div>
	);
};
